// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M15.972.06c-.136.056-.43.345-5.631 5.547-4.298 4.298-5.508 5.52-5.575 5.635a1.53 1.53 0 0 0-.048 1.43c.086.176.195.288 5.598 5.693 5.972 5.976 5.584 5.604 5.878 5.63.321.028.66-.194.762-.498a.868.868 0 0 0-.034-.577c-.04-.079-1.507-1.56-5.458-5.514L6.06 12l5.404-5.406c3.951-3.953 5.418-5.435 5.458-5.514a.867.867 0 0 0 .033-.578.878.878 0 0 0-.334-.402.728.728 0 0 0-.649-.04"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ChevronLeftIcon = Icon;
export default ChevronLeftIcon;
